import React, { useState, useEffect } from "react";
import ConfirmDialog from "../../../utils/ConfirmDialog";
import SolutionForm from "./SolutionForm";
import SolutionGrid from "./SolutionGrid";
const UploadSolution = () => {
  const [data, setData] = useState([]);
  const [view, setView] = useState("grid");
  const [editIndex, setEditIndex] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const showData = () => {
    fetch("https://kvrstarlightmedicalacademy.com/api/examsolution.php")
      .then((response) => response.json())
      .then((data) => setData(data));
  };

  useEffect(() => {
    showData();
  }, []);
  const handleCreate = () => {
    setEditIndex(null);
    setView("form");
    showData();
  };
  const handleDelete = (id) => {
    setDeleteId(id);
  };
  const confirmDelete = async () => {
    const imageToDelete = data[deleteId];
    console.log(imageToDelete);

    try {
      const res = await fetch("https://kvrstarlightmedicalacademy.com/api/examsolution.php", {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(imageToDelete),
      });

      if (res.ok) {
        console.info("Successfully Loaded");
      } else {
        console.error("Delete error:", res.status);
      }
    } catch (err) {
      console.error("Fetch error:", err);
    }

    setDeleteId(null);
    showData();
  };

  const cancelDelete = () => {
    setDeleteId(null);
  };

  const handleFormSubmit = async (file) => {
    const formData = new FormData();
    formData.append("image", file);

    try {
      const res = await fetch("https://kvrstarlightmedicalacademy.com/api/examsolution.php", {
        method: "POST",
        body: formData,
      });

      if (res.ok) {
        const result = await res.json();

        console.log("Upload success:", result);
      } else {
        console.error("Upload error:", res.status);
      }
    } catch (err) {
      console.error("Fetch error:", err);
    }

    setView("grid");
    showData();
  };

  return (
    <div className="container mt-4">
      {view === "grid" ? (
        <SolutionGrid
          data={data}
          onCreate={handleCreate}
          onDelete={handleDelete}
        />
      ) : (
        <SolutionForm
          onSubmit={handleFormSubmit}
          onCancel={() => setView("grid")}
        />
      )}
      {deleteId !== null && (
        <ConfirmDialog
          message="Are you sure you want to delete this Solution?"
          onConfirm={confirmDelete}
          onCancel={cancelDelete}
        />
      )}
    </div>
  );
};

export default UploadSolution;
